import React from 'react';
import PropTypes from 'prop-types';

import stylesCourse from 'styles/Course.module.scss';
import { parseHtml } from 'helpers';

const FormatContent = (props) => {
  const {
    list,
    showCorrect,
    commonHeight,
    correctanswerlebal,
    isLabel,
    iconsShow,
    CorrectLebal,
    isCorrectLabel,
    isYourans,
  } = props;
  return (
    <>
      {list?.map((item, index) => (
        <div key={index}>
          <div
            className={
              `cursor-pointer flexRow ${stylesCourse['item-section-normal']}` +
              ` ${stylesCourse['item-section-enabled']}` +
              ` ${stylesCourse['animation-height']}`
            }
            style={{
              maxWidth: '40rem',
              height:
                !commonHeight || !commonHeight?.length === 0
                  ? '100%'
                  : commonHeight[index],
              '--labelcolor': iconsShow
                ? showCorrect
                  ? isLabel
                    ? '#19a356'
                    : isCorrectLabel && item?.correct
                    ? '#19a356'
                    : '#e16969'
                  : '#c1c9d4'
                : '#c1c9d4',
            }}
          >
            {iconsShow
              ? showCorrect &&
                isLabel && (
                  <div
                    className="preview_test_correct_lebalgrade"
                    style={{ marginLeft: 'auto', marginBottom: 'auto' }}
                  >
                    Correct
                  </div>
                )
              : null}
            {iconsShow ? (
              isCorrectLabel && showCorrect ? (
                <>
                  {item?.correct ? (
                    <div
                      className="preview_test_correct_lebalgrade"
                      style={{ marginLeft: 'auto', marginBottom: 'auto' }}
                    >
                      Correct
                    </div>
                  ) : (
                    <div
                      className="preview_test_wrong_lebalgrade"
                      style={{ marginLeft: 'auto', marginBottom: 'auto' }}
                    >
                      Incorrect
                    </div>
                  )}
                </>
              ) : null
            ) : null}
            <span
              className={`w-100 px-md-2 px-05 py-05 ${stylesCourse['item-unit-label']}`}
            >
              <span
                className={`drag-overflow-image ${stylesCourse['item-unit-title']}`}
              >
                {parseHtml(isYourans ? item?.answer : item?.content || item)}
              </span>
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

FormatContent.propTypes = {
  list: PropTypes.array.isRequired,
};

export default FormatContent;
